import React, { useState } from 'react';
import {
    RocketLaunch as RocketIcon,
    ShoppingCart as CartIcon,
    Payment as PaymentIcon,
    Inventory as InventoryIcon,
    Speed as OptimizeIcon,
    PhoneAndroid as MobileIcon,
    Security as SecurityIcon,
    Bolt as BoltIcon,
    ArrowRight as ArrowRightIcon,
    CheckCircle as CheckCircleIcon,
    Palette as DesignIcon,
    Scale as ScaleIcon
} from '@mui/icons-material';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Container,
    Divider,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Stack,
    Typography,
    useTheme,
    alpha
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ecommerce  from '../../../assets/other/eCommerce.jpg';
import backImg from '../../../assets/other/background1.jpg';
import { useNavigate } from 'react-router-dom';


const EcommercePage = () => {
    const theme = useTheme();
    const [hoveredCard, setHoveredCard] = useState(null);
    const navigate = useNavigate();

    const services = [
        {
            icon: <CartIcon fontSize="large" />,
            title: "E-Commerce Development",
            description: "Complete online store solutions with custom features tailored to your business needs.",
            image: "https://i.pinimg.com/736x/6d/bd/4d/6dbd4d7ef7f9c3507fe4d411602f7f26.jpg?w=500&h=300&fit=crop"
        },
        {
            icon: <PaymentIcon fontSize="large" />,
            title: "Payment Gateway Integration",
            description: "Secure payment processing with multiple payment options for global customers.",
            image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*mhiqJIyiC9xJ0yUEj2r-Ug.png?w=500&h=300&fit=crop"
        },
        {
            icon: <InventoryIcon fontSize="large" />,
            title: "Inventory Management",
            description: "Real-time stock tracking and automated inventory control systems.",
            image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&h=300&fit=crop"
        },
        {
            icon: <OptimizeIcon fontSize="large" />,
            title: "Shopping Cart Optimization",
            description: "Reduce cart abandonment with streamlined checkout processes.",
            image: "https://cdn.prod.website-files.com/605826c62e8de87de744596e/663dfbe0d5744d369d42bacc_2024-5-7-122453638-663df7a883b63.webp?w=500&h=300&fit=crop"
        },
        {
            icon: <MobileIcon fontSize="large" />,
            title: "Mobile Commerce",
            description: "Mobile-optimized shopping experiences with app-like functionality.",
            image: "https://www.fatbit.com/fab/wp-content/uploads/2018/01/mobile-shopping-1024x1024.jpg?w=500&h=300&fit=crop"
        }
    ];

    const benefits = [
        { icon: <BoltIcon />, title: "Expertise", description: "Deep knowledge of e-commerce trends and technologies" },
        { icon: <DesignIcon />, title: "Tailored Solutions", description: "Customized services for your unique needs" },
        { icon: <CheckCircleIcon />, title: "User-Centric", description: "Intuitive designs that convert visitors" },
        { icon: <ScaleIcon />, title: "Scalability", description: "Solutions that grow with your business" },
        { icon: <SecurityIcon />, title: "Security", description: "Robust protection for customer data" }
    ];

    return (
        <Box sx={{ bgcolor: 'background.default' }}>
            {/* Hero Section */}
            {/* <Box sx={{
                position: 'relative',
                bgcolor: 'rgba(63, 81, 181, 0.9)',
                color: 'primary.contrastText',
                py: 12,
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.2)} 0%, ${alpha(theme.palette.primary.main, 0.2)} 100%)`,
                    zIndex: 1
                }
            }}>  */}
       <Box sx={{
    position: 'relative',
    bgcolor: 'rgba(63, 81, 181, 0.9)',
    color: 'primary.contrastText',
    py: 12,
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `radial-gradient(circle, 
            ${alpha(theme.palette.secondary.main, 0.1)} 1px, 
            transparent 1px)`,
        backgroundSize: '20px 20px',
        animation: 'floatParticles 40s linear infinite',
        zIndex: 1,
    },
    '@keyframes floatParticles': {
        '0%': { backgroundPosition: '0 0' },
        '100%': { backgroundPosition: '1000px 1000px' },
    }
}}>
                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
                    <Stack alignItems="center" textAlign="center" spacing={4}>
                        <Chip
                        onClick={()=>console.log("")}
                            icon={<ShoppingCartIcon />}
                            label="Elevate Your E-Commerce Success"
                            sx={{
                                bgcolor: 'rgba(255, 255, 255, 0.2)',
                                color: 'primary.contrastText',
                                px: 2,
                                py: 1,
                                fontSize: '0.875rem'
                            }}
                        />

                        <Typography variant="h2" component="h1" sx={{ fontWeight: 700, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
                            E-Commerce <Box component="span" sx={{ color: '#ffeb3b' }}>Solutions</Box>
                        </Typography>

                        <Typography variant="h5" sx={{ maxWidth: 800, opacity: 0.9 }}>
                            Your online store is the gateway to unprecedented growth. We create e-commerce platforms that drive sales and customer loyalty.
                        </Typography>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                endIcon={<ArrowRightIcon />}
                                sx={{
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '1rem',
                                    '&:hover': {
                                        transform: 'translateY(-2px)'
                                    }
                                }}
                                onClick={()=> navigate('/get-in-touch')}
                            >
                                Launch Your Store
                            </Button>

                            <Button
                                variant="outlined"
                                color="inherit"
                                onClick={()=> navigate('/case-studies')}
                                size="large"
                                sx={{
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '1rem',
                                    borderColor: alpha(theme.palette.common.white, 0.3),
                                    color: 'primary.contrastText',
                                    '&:hover': {
                                        borderColor: theme.palette.common.white,
                                        bgcolor: alpha(theme.palette.common.white, 0.1)
                                    }
                                }}
                            >
                                View Demos
                            </Button>
                        </Stack>
                    </Stack>
                </Container>
            </Box>

            {/* Vision Section */}
            <Container maxWidth="lg" sx={{ py: 10 }}>
                <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                        <Typography variant="h3" component="h2" sx={{ fontWeight: 700, mb: 3 }}>
                            Our E-Commerce Vision
                        </Typography>
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
                            We're passionate about e-commerce and driven by innovation. Our mission is to create solutions that look exceptional and perform flawlessly.
                        </Typography>
                        <List dense>
                            {[
                                "Conversion-focused designs",
                                "Mobile-first approach",
                                "SEO-optimized architecture",
                                "Lightning-fast performance",
                                "24/7 technical support"
                            ].map((item, index) => (
                                <ListItem key={index} disableGutters>
                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary={item} />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                    <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                        <Box
                            component="img"
                            src={ecommerce}
                            alt="E-Commerce Solutions"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: theme.shadows[4],
                                transition: 'transform 0.3s ease',
                                '&:hover': {
                                    transform: 'scale(1.02)'
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>

            {/* Why Choose Us Section */}
            <Box sx={{ bgcolor: 'grey.50', py: 10 }}>
                <Stack spacing={6} alignItems="center" textAlign="center">
                                    <Typography
                                      variant="h3"
                                      component="h2"
                                      sx={{
                                        fontWeight: 800,
                                        color: 'primary.main',
                                        fontSize: { xs: '2rem', md: '2.75rem' },
                                      }}
                                    >
                                      Why Choose ShreeshTech?
                                    </Typography>
                            
                            
                            
                                    <Grid container spacing={4} justifyContent="center">
                                      {benefits.map((benefit, index) => (
                                        <Grid
                                          item
                                          xs={12}
                                          sm={6}
                                          md={4}
                                          lg={3}
                                          key={index}
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <Paper
                                            elevation={3}
                                            sx={{
                                              p: 4,
                                              width: '100%',
                                              maxWidth: 280, // Ensures same width
                                              minHeight: 260,
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              textAlign: 'center',
                                              borderRadius: 3,
                                              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                              '&:hover': {
                                                transform: 'translateY(-6px)',
                                                boxShadow: theme => theme.shadows[6],
                                                bgcolor: theme => alpha(theme.palette.primary.light, 0.05),
                                              },
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: 64,
                                                height: 64,
                                                bgcolor: 'primary.main',
                                                color: 'primary.contrastText',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 32,
                                                mb: 2,
                                              }}
                                            >
                                              {benefit.icon}
                                            </Box>
                            
                                            <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
                                              {benefit.title}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                              {benefit.description}
                                            </Typography>
                                          </Paper>
                                        </Grid>
                                      ))}
                                    </Grid>
                            
                                  </Stack>
            </Box>

            {/* Services Section */}
            <Container maxWidth="lg" sx={{ py: 10 }}>
                <Stack spacing={6} alignItems="center" textAlign="center">
                    <Typography variant="h3" component="h2" sx={{ fontWeight: 700 }}>
                        Our E-Commerce Services
                    </Typography>

                    <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 700 }}>
                        Comprehensive solutions to power your online business and drive sales
                    </Typography>

                    <Grid container spacing={4} justifyContent="center">
                        {services.map((service, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
                                <Card
                                    elevation={hoveredCard === index ? 6 : 2}
                                    onMouseEnter={() => setHoveredCard(index)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    sx={{
                                        width: '100%',
                                        maxWidth: 380,
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-8px)'
                                        }
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        height="200"
                                        image={service.image}
                                        alt={service.title}
                                        sx={{
                                            objectFit: 'cover',
                                            objectPosition: 'center'
                                        }}
                                    />
                                    <CardContent sx={{ 
                                        p: { xs: 3, md: 4 },
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        <Box
                                            sx={{
                                                width: 64,
                                                height: 64,
                                                bgcolor: 'primary.light',
                                                color: 'primary.contrastText',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 3,
                                                mx: 'auto',
                                                transition: 'all 0.3s ease',
                                                ...(hoveredCard === index && {
                                                    transform: 'scale(1.1)',
                                                    bgcolor: 'secondary.main'
                                                })
                                            }}
                                        >
                                            {service.icon}
                                        </Box>
                                        <Typography variant="h5" component="h3" gutterBottom>
                                            {service.title}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {service.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Stack>
            </Container>

            {/* CTA Section */}
            <Box sx={{
                bgcolor: 'rgba(63, 81, 181, 0.9)',
                color: 'primary.contrastText',
                py: 10,
                backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.2)} 0%, ${alpha(theme.palette.primary.main, 0.2)} 100%)`
            }}>
                <Container maxWidth="lg">
                    <Stack spacing={4} alignItems="center" textAlign="center">
                        <Typography variant="h3" component="h2" sx={{ fontWeight: 700 }}>
                            Ready to Boost Your Online Sales?
                        </Typography>

                        <Typography variant="h6" sx={{ maxWidth: 700, opacity: 0.9 }}>
                            Your e-commerce platform is more than just a website - it's your digital storefront to the world.
                        </Typography>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                sx={{
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '1rem'
                                }}
                            >
                                Start Selling Online
                            </Button>

                            <Button
                                variant="outlined"
                                color="inherit"
                                size="large"
                                sx={{
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '1rem',
                                    borderColor: alpha(theme.palette.common.white, 0.3),
                                    color: 'primary.contrastText',
                                    '&:hover': {
                                        borderColor: theme.palette.common.white,
                                        bgcolor: 'rgba(233, 30, 99, 0.9)',
                                    }
                                }}
                            >
                                Free Consultation
                            </Button>
                        </Stack>
                    </Stack>
                </Container>
            </Box>
        </Box>
    );
};

export default EcommercePage;